import React, { Component } from 'react';
import { EconomicalScoreTrackerPlayer } from '../stateless/eco-score-player';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';
import { players } from '../../constants/images';

/**
 * @class EconomicalScoreTracker
 *
 * @description
 * Class for.
 *
 * @example
 * <EconomicalScoreTracker />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : { options: [] };
		let activeStep = state.step.activeStep && state.setup[state.step.activeStep.ref][state.step.activeStep.id];
		if (activeStep && (activeStep.male || activeStep.female)) {
			activeStep = activeStep.male || activeStep.female;
		}

		return {
			step: state.step,
			results: state.results,
			activePlayers: (activeStep && activeStep.windows && activeStep.windows[state.currentWindow.index]) && activeStep.windows[state.currentWindow.index].players,
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class EconomicalScoreTracker extends Component {

	static propTypes = {};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { currentValue, activePlayers, window } = this.props;
		const max = (window.current && window.current.answers && window.current.answers.range) ? window.current.answers.range.max : null;
		const playerAvatar = buildAvatar(this.props, false);
		return (activePlayers && max)? (
			<div className={'eco-score-tracker__standard'}>
				<EconomicalScoreTrackerPlayer score={max - currentValue}
																			imgSrc={playerAvatar} />
				<EconomicalScoreTrackerPlayer score={currentValue || 0}
																			imgSrc={players[activePlayers[1]]} />
			</div>
		) : null;
	}
}
